(function () {
  if (customElements.get('mairaz-instagram-reels')) return;

  class MairazInstagramReels extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-reels-rail]');
      this.empty = this.querySelector('[data-reels-empty]');
      this.modal = this.querySelector('[data-reels-modal]');
      this.embed = this.querySelector('[data-reels-embed]');
      this.modalTitle = this.querySelector('[data-reels-modal-title]');
      this.modalCaption = this.querySelector('[data-reels-modal-caption]');
      this.instagramLink = this.querySelector('[data-reels-instagram-link]');
      this.shopLink = this.querySelector('[data-reels-shop-link]');
      this.lastTrigger = null;

      if (!this.rail || !this.modal) return;

      this.addEventListener('click', this.onClick.bind(this));
      this.rail.addEventListener('scroll', this.updateArrows.bind(this), { passive: true });
      document.addEventListener('keydown', this.onKeydown.bind(this));
      this.updateArrows();
      this.loadOfficialFeed();
    }

    async loadOfficialFeed() {
      var endpoint = this.dataset.feedEndpoint;
      if (!endpoint) {
        this.updateEmptyState();
        return;
      }

      try {
        var url = new URL(endpoint, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('The feed endpoint must be same-origin.');
        url.searchParams.set('limit', this.dataset.limit || '16');

        var response = await fetch(url.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Instagram feed unavailable.');

        var payload = await response.json();
        var reels = Array.isArray(payload.reels) ? payload.reels : [];
        reels = reels
          .filter(this.isValidReel.bind(this))
          .sort(function (a, b) {
            return new Date(b.timestamp || 0).getTime() - new Date(a.timestamp || 0).getTime();
          })
          .filter(function (reel, index, all) {
            var key = reel.id || reel.permalink;
            return all.findIndex(function (item) { return (item.id || item.permalink) === key; }) === index;
          })
          .slice(0, Math.min(20, Math.max(10, Number(this.dataset.limit) || 16)));

        if (reels.length) this.renderReels(reels);
      } catch (error) {
        this.dataset.feedState = 'fallback';
      }

      this.updateEmptyState();
      this.updateArrows();
    }

    isValidReel(reel) {
      if (!reel || !reel.permalink || !reel.thumbnail_url) return false;
      try {
        var url = new URL(reel.permalink);
        var host = url.hostname.toLowerCase().replace(/^www\./, '');
        return host === 'instagram.com' && /^\/(reel|p)\//.test(url.pathname);
      } catch (error) {
        return false;
      }
    }

    safeProductUrl(value) {
      if (!value) return '';
      try {
        var url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || !url.pathname.startsWith('/products/')) return '';
        if (!url.searchParams.has('utm_source')) url.searchParams.set('utm_source', 'instagram');
        if (!url.searchParams.has('utm_medium')) url.searchParams.set('utm_medium', 'reel');
        if (!url.searchParams.has('utm_campaign')) url.searchParams.set('utm_campaign', 'shop_instagram');
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return '';
      }
    }

    renderReels(reels) {
      var fragment = document.createDocumentFragment();

      reels.forEach(function (reel) {
        var item = document.createElement('li');
        item.className = 'mrz-reels__item';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'mrz-reels__card';
        button.dataset.reelUrl = reel.permalink;
        button.dataset.caption = reel.caption || '';
        button.dataset.productUrl = this.safeProductUrl(reel.product_url);
        button.dataset.productTitle = reel.product_title || '';
        button.setAttribute('aria-label', reel.caption ? 'Watch Reel: ' + reel.caption.slice(0, 100) : 'Watch Instagram Reel');

        var media = document.createElement('span');
        media.className = 'mrz-reels__media';
        var image = document.createElement('img');
        image.className = 'mrz-reels__image';
        image.src = reel.thumbnail_url;
        image.alt = reel.alt_text || reel.caption || 'Mairaz Instagram Reel preview';
        image.loading = 'lazy';
        image.decoding = 'async';
        image.width = 540;
        image.height = 960;
        media.appendChild(image);

        var play = document.createElement('span');
        play.className = 'mrz-reels__play';
        play.setAttribute('aria-hidden', 'true');
        play.innerHTML = '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M5.8 3.5v13l10-6.5-10-6.5Z"/></svg>';
        media.appendChild(play);

        if (reel.caption) {
          var caption = document.createElement('span');
          caption.className = 'mrz-reels__caption';
          caption.textContent = reel.caption;
          media.appendChild(caption);
        }

        button.appendChild(media);
        item.appendChild(button);
        fragment.appendChild(item);
      }, this);

      this.rail.replaceChildren(fragment);
      this.dataset.feedState = 'official';
    }

    updateEmptyState() {
      if (!this.empty) return;
      this.empty.hidden = this.dataset.hasAppFeed === 'true' || Boolean(this.rail.querySelector('[data-reel-url], .mrz-reels__card'));
    }

    onClick(event) {
      var arrow = event.target.closest('[data-reels-direction]');
      if (arrow) {
        var direction = arrow.dataset.reelsDirection === 'next' ? 1 : -1;
        this.rail.scrollBy({ left: direction * this.rail.clientWidth * .88, behavior: 'smooth' });
        return;
      }

      if (event.target.closest('[data-reels-close]') || event.target === this.modal) {
        this.closeModal();
        return;
      }

      var card = event.target.closest('[data-reel-url]');
      if (card) this.openModal(card);
    }

    instagramEmbedUrl(permalink) {
      try {
        var url = new URL(permalink);
        var host = url.hostname.toLowerCase().replace(/^www\./, '');
        if (host !== 'instagram.com' || !/^\/(reel|p)\//.test(url.pathname)) return '';
        var cleanPath = url.pathname.replace(/\/$/, '');
        return 'https://www.instagram.com' + cleanPath + '/embed/';
      } catch (error) {
        return '';
      }
    }

    openModal(card) {
      var permalink = card.dataset.reelUrl;
      var embedUrl = this.instagramEmbedUrl(permalink);
      if (!embedUrl) return;

      this.lastTrigger = card;
      var iframe = document.createElement('iframe');
      iframe.src = embedUrl;
      iframe.title = card.dataset.caption ? 'Instagram Reel: ' + card.dataset.caption.slice(0, 100) : 'Instagram Reel';
      iframe.loading = 'lazy';
      iframe.allow = 'encrypted-media; picture-in-picture';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      this.embed.replaceChildren(iframe);

      var productTitle = card.dataset.productTitle || '';
      var caption = card.dataset.caption || '';
      this.modalTitle.textContent = productTitle || 'Latest From Instagram';
      this.modalCaption.textContent = caption;
      this.modalCaption.hidden = !caption;
      this.instagramLink.href = permalink;

      var productUrl = this.safeProductUrl(card.dataset.productUrl);
      this.shopLink.hidden = !productUrl;
      if (productUrl) this.shopLink.href = productUrl;

      this.modal.hidden = false;
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('mrz-reels-modal-open');
      this.querySelector('[data-reels-close]').focus();
    }

    closeModal() {
      if (this.modal.hidden) return;
      this.modal.hidden = true;
      this.modal.setAttribute('aria-hidden', 'true');
      this.embed.replaceChildren();
      document.body.classList.remove('mrz-reels-modal-open');
      if (this.lastTrigger) this.lastTrigger.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && !this.modal.hidden) this.closeModal();
    }

    updateArrows() {
      var previous = this.querySelector('[data-reels-direction="previous"]');
      var next = this.querySelector('[data-reels-direction="next"]');
      if (!previous || !next || !this.rail) return;
      previous.disabled = this.rail.scrollLeft <= 4;
      next.disabled = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 4;
    }
  }

  customElements.define('mairaz-instagram-reels', MairazInstagramReels);
})();
